import { render, staticRenderFns } from "./Catering2.vue?vue&type=template&id=ba4a6ece&scoped=true&"
import script from "./Catering2.vue?vue&type=script&lang=js&"
export * from "./Catering2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4a6ece",
  null
  
)

export default component.exports